import { baseVariables, toRem } from '../../styles';
import styled from 'styled-components';

export const StyledCarouselGallery = styled.div<{ variation: string }>`
  .aem-container:first-child {
    margin-left: 0;
  }
  .glide {
    &__track {
      padding-top: ${props => (props.variation === 'carouselTriptych' ? toRem(24) : '0')};
      .glide__slides_authoring {
        width: 100% !important;
        flex-wrap: wrap;
      }
      .glide__slides {
        .aem-container {
          padding: 0;
        }
      }
      ul {
        margin-left: ${props => (props.variation === 'carouselTriptych' ? toRem(-8) : '')};
      }
    }
    .glide__slides > .cq-Editable-dom > .cq-Editable-dom--container {
      display: contents;
    }
    .glide__slide {
      margin: auto;
      ${props =>
        props.variation === 'carouselHero' &&
        `
          picture {
            display: flex;
            justify-content: center;
          }
        `}
      img {
        width: 100%;
        max-width: 100%;
        object-fit: cover;
        ${props =>
          props.variation === 'carouselHero' &&
          `
            max-height: 100vw;
            @media ${baseVariables.mediaQuery.md} {
              max-height: 56.25vw;
              aspect-ratio: 16/9;
            }
            @media ${baseVariables.mediaQuery.lg} {
              max-height: 33.33vw;
              aspect-ratio: 3/1;
            }
            @media screen and (min-width: 1921px) {
              height: ${toRem(768)};
              max-height: ${toRem(768)};
              max-width: ${toRem(1920)};
            }
          `}
      }
    }
    .glide__slide:not(.glide__slide--active) {
      transform: ${props => (props.variation === 'carouselHero' ? 'none' : 'scaleY(0.909);')};
      transition: ${props => (props.variation === 'carouselHero' ? 'none' : 'transform 400ms ease-out;')};
    }
    .glide__slide.glide__slide--active {
      transition: ${props => (props.variation === 'carouselHero' ? 'none' : 'transform 400ms ease-out;')};
    }
    .center-align-controls {
      display: flex;
      position: ${props => (props.variation === 'carouselHero' ? 'absolute' : '')};
      bottom: ${props => (props.variation === 'carouselHero' ? toRem(24) : '')};
      justify-content: center;
      align-items: center;
      width: auto;
      left: 0;
      right: 0;
      margin-top: ${props => (props.variation === 'carouselTriptych' ? toRem(24) : '')};
      margin-bottom: ${props => (props.variation === 'carouselTriptych' ? toRem(24) : '')};
    }
  }
  .glide--swipeable {
    cursor: default;
  }
  button {
    &:focus-visible {
      outline: ${toRem(2)} solid #007bff;
      border-radius: ${toRem(2)};
      outline-offset: ${toRem(2)};
    }
  }
  ul {
    list-style: none;
  }
`;
